import { z } from 'zod';

export const customerSchema = z.object({
  id: z.string().optional(),
  type: z.enum(['PF', 'PJ']),
  name: z.string().min(3, 'Nome deve ter no mínimo 3 caracteres'),
  document: z.string()
    .min(11, 'CPF/CNPJ inválido')
    .refine((val) => {
      const numbers = val.replace(/\D/g, '');
      return numbers.length === 11 || numbers.length === 14;
    }, 'CPF/CNPJ inválido'),
  email: z.string().email('E-mail inválido'),
  phone: z.string()
    .min(10, 'Telefone inválido')
    .refine((val) => {
      const numbers = val.replace(/\D/g, '');
      return numbers.length >= 10 && numbers.length <= 11;
    }, 'Telefone inválido'),
  whatsapp: z.string().optional(),
  status: z.enum(['active', 'inactive', 'blocked']).default('active'),
  address_street: z.string().min(3, 'Endereço inválido'),
  address_number: z.string().min(1, 'Número inválido'),
  address_complement: z.string().optional(),
  address_neighborhood: z.string().min(2, 'Bairro inválido'),
  address_city: z.string().min(2, 'Cidade inválida'),
  address_state: z.string().min(2, 'Estado inválido'),
  address_zip: z.string()
    .min(8, 'CEP inválido')
    .refine((val) => {
      const numbers = val.replace(/\D/g, '');
      return numbers.length === 8;
    }, 'CEP inválido'),
  notes: z.string().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional()
});

export type Customer = z.infer<typeof customerSchema>;

export interface CustomerPurchase {
  id: string;
  date: Date;
  products: {
    id: string;
    name: string;
    quantity: number;
    price: number;
  }[];
  total: number;
  paymentMethod: string;
  status: 'paid' | 'pending' | 'overdue';
}

export interface CustomerDocument {
  id: string;
  name: string;
  type: string;
  url: string;
  uploadedAt: Date;
}